// extracted by mini-css-extract-plugin
export default {"notesHeader":"DatabaseTab_notesHeader__1xM2e","notesCount":"DatabaseTab_notesCount__V3sOt","CustomTab":"DatabaseTab_CustomTab__4utAF"};